export function getInstance () {
  // for amex the global window reference acts as the SDK constructor
  // function. getInstance will return the SDK instance and
  // ensure that only once instance is instantiated (singleton)
  if (!window.opener) {
    return window.AmexSS.getInstance()
  } else {
    return window.opener.AmexSS.getInstance()
  }
}
